import {cs}       from "./chain-services";
import {UseState} from "./use-state";

export const UpwardProxy = ({state, allow = (v) => true, mod=v=>v,keepCache = (v) => true, next}) => cs(
    ["buffer", (_, next) => UseState({next})],
    ({buffer}) => next({
        state: {
            value: buffer.value != null ? buffer.value.value : state.value,
            onChange: (newValue) => {

                if (allow(newValue)) {
                    state.onChange(mod(newValue));

                    if (keepCache(newValue)) {
                        buffer.onChange({value: newValue});
                    } else if (buffer.value) {
                        buffer.onChange(null);
                    }
                } else {
                    buffer.onChange({value: newValue});
                }
            },
        },
        flush: () => {
            buffer.onChange(null);
        },
    }),
);
